import React, { useEffect, useRef } from 'react';
import { Text } from '@input';
import { isValidEmail } from '@helpers';

export default function RateModalEmail({
  emailState,
  setEmailState,
  isVisible
}) {
  const hasError = emailState.canShowError && !emailState.isValid;
  const ref = useRef();

  // Check ref value on first load just in case
  // the browser autofilled the input field
  useEffect(() => {
    const timer = setTimeout(() => {
      const value = ref.current?.value;

      if (value) {
        setEmailState(emailState => {
          const isValid = isValidEmail(value);

          setEmailState({
            ...emailState,
            value,
            isValid,
            lastValidEmail: isValid ? value : emailState.lastValidEmail
          });
        });
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [setEmailState]);

  useEffect(() => {
    if (isVisible && !emailState.isValid && ref.current) {
      ref.current.focus();
    }
  }, [isVisible, emailState.isValid]);

  return (
    <Text
      ref={ref}
      value={emailState.value}
      name="email"
      aria-labelledby="modal-form-apply-email"
      placeholder="Enter your email address"
      autoComplete="email"
      hasError={hasError}
      errorMessage="Enter a valid email"
      showErrorMessage={hasError}
      onChange={value => {
        const isValid = isValidEmail(value);

        setEmailState({
          ...emailState,
          value,
          isValid,
          lastValidEmail: isValid ? value : emailState.lastValidEmail
        });
      }}
      onBlur={value => {
        if (emailState.value && !emailState.canShowError) {
          setEmailState({ ...emailState, value, canShowError: true });
        }
      }}
    />
  );
}
